import { Component, EventEmitter, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'gtw-browser-detection',
    templateUrl: './browser-detection.component.html',
    styleUrls: ['./browser-detection.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class BrowserDetectionComponent implements OnInit {

  @Output('request-grid-update') requestGridUpdate = new EventEmitter<any>();

  title: string = 'GTW';
  url: string = '';
  minimise: boolean = false;

  constructor() {}

  ngOnInit(): void {
    this.url = window.location.href;
  }

  close(): void {
    const updateEvent = new CustomEvent('request-grid-update', {
      detail: 'cancel',
      bubbles: true
    });
    if (document.querySelector('gtw-browser-detection-ce')) {
      document.querySelector('gtw-browser-detection-ce')?.dispatchEvent(updateEvent);
    }
  }
}
